import { analytics } from '@/utils/analytics';
import { getShareLink } from '@/utils/getShareLink';
import { HELIKA_EVENT_TYPE } from '@/utils/helika';
import { openTelegramLink } from '@/utils/openTelegramLink';

export const shareLink = (inviteCode: string | null) => {
  openTelegramLink(getShareLink({ inviteCode }));

  analytics.sendEvent({
    event_type: HELIKA_EVENT_TYPE.FEATURE,
    event: {
      event_sub_type: 'profile_invite',
      event_details: {
        event_label: 'Invite friend',
        event_action: 'invite',
      },
    },
  });
};

export const shareOpinionLink = (opinionId: string, inviteCode: string) => {
  openTelegramLink(
    getShareLink({
      inviteCode,
      opId: opinionId,
    }),
  );

  analytics.sendEvent({
    event_type: HELIKA_EVENT_TYPE.FEATURE,
    event: {
      event_sub_type: 'opinion_share',
      event_details: {
        event_label: 'Share opinion',
        event_action: 'share',
      },
      opinion_id: opinionId,
    },
  });
};

export const shareTournamentLink = (
  tournamentId: string,
  inviteCode: string,
) => {
  openTelegramLink(getShareLink({ inviteCode, tournamentId }));

  analytics.sendEvent({
    event_type: HELIKA_EVENT_TYPE.FEATURE,
    event: {
      event_sub_type: 'tournament_share',
      event_details: {
        event_label: 'Share tournament',
        event_action: 'share',
      },
      tournament_id: tournamentId,
    },
  });
};

export const shareProfileLink = (profileId: string, inviteCode: string) => {
  openTelegramLink(
    getShareLink({
      inviteCode,
      profId: profileId,
    }),
  );

  analytics.sendEvent({
    event_type: HELIKA_EVENT_TYPE.FEATURE,
    event: {
      event_sub_type: 'profile_share',
      event_details: {
        event_label: 'Share profile',
        event_action: 'share',
      },
      profile_id: profileId,
    },
  });
};
